import React from 'react'

import Container from './components/Container'
import { Provider } from 'mobx-react'
import { uiStore, dataStore, selectionStore, rightSidebarStore, manageModalStore } from 'stores/UIStore'
import ErrorStore from 'stores/ErrorStore'

const Dashboard = () => {
  return (
    <Provider
      uiStore={uiStore}
      dataStore={dataStore}
      selectionStore={selectionStore}
      rightSidebarStore={rightSidebarStore}
      manageModalStore={manageModalStore}
      errorStore={ErrorStore}
    >
      <Container />
    </Provider>
  )
}

export default Dashboard
